import { useCallback, useMemo, useState } from 'react';
import { LinearProgress } from '@mui/material';
import { useStore } from 'common/store';
import LayoutContext, { LayoutContextType } from 'context/LayoutContext';
import LoadingPaper from 'pages/Login/components/LoadingPaper';
import { AuthLayoutProps } from './AuthLayout.props';
import { StyledFormContainer, StyledGridContainer, StyledGridItem } from './AuthLayout.styles';
import FirstViewLogo from './components/FirstViewLogo';

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const [showPageForm, setShowPageForm] = useState(false);
  const [loading, setLoading] = useState(true);

  const togglePageForm = useCallback(() => setShowPageForm(!showPageForm), [showPageForm]);
  const [{ isShowLoadingProgress }] = useStore();

  const layoutContextProps = useMemo(
    () =>
      ({
        showPageForm,
        setShowPageForm,
        togglePageForm,
      }) as LayoutContextType,
    [showPageForm, setShowPageForm, togglePageForm]
  );

  return (
    <LayoutContext.Provider value={layoutContextProps}>
      {isShowLoadingProgress && <LinearProgress color="primary" />}
      <LoadingPaper isFullScreen loading={loading} />

      <StyledGridContainer container style={loading ? { display: 'none' } : {}}>
        <StyledGridItem isLoading={loading}>
          <FirstViewLogo loading={loading} setLoading={setLoading} />
        </StyledGridItem>

        <StyledGridItem>
          <StyledFormContainer>{children}</StyledFormContainer>
        </StyledGridItem>
      </StyledGridContainer>
    </LayoutContext.Provider>
  );
};

export default AuthLayout;
